import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
import { StudentIssueViewModel, ToggleTodoItemRequest } from 'edu-application/dist'
@Injectable({
  providedIn: 'root'
})
export class IssuesService {

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }
  /**
   * This method is used to get the issues of a student
   * @param username The username of the student
   * @returns A promise that resolves to an array of StudentIssueViewModel
   */
  getStudentIssues(username: string, organizationId: string): Promise<StudentIssueViewModel[]> {
    if (this.loginService.isLoggedIn) {
      const userInfo = this.loginService.userInfo;
      if (userInfo.type == "student" && userInfo.userName != username) {
        throw new Error("You are not allowed to view other students' issues");
      }
    }
    return this.http.get<StudentIssueViewModel[]>(`${environment.backend_url}/issues/students?username=${username}&organizationId=${organizationId}`).toPromise();
  }

  /**
   * This method is used to toggle the status of a todo item
   * @param request The request object containing information about the todo item to toggle
   * @returns A promise that resolves when the toggle operation is complete
   */
  toggleTodoItem(request: ToggleTodoItemRequest) {
    return this.http.put<void>(`${environment.backend_url}/issues/todo-items`, request).toPromise();
  }
}
